import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Service from '../Service/Service';

const Services = () => {
    // defining state
    const [services, setServices] = useState([]);
    useEffect(() => {
        // fetching data from API
        fetch('./services.JSON')
            .then(res => res.json())
            .then(data => setServices(data))
    }, [])
    return (
        <div>
            {/*Adding page title*/}
            <h1 className="fs-1 mb-3">Our Services</h1>
            < hr className="w-25 mx-auto mb-5" />
            {/*show services*/}
            <Row xs={1} md={3} className="w-75 g-5 mx-auto mb-5">
                {
                    services.map(service => <Service
                        key={service.id}
                        service={service}></Service>)
                }
            </Row>
        </div>
    );
};

export default Services;